module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('edit-pane', {
    ref: "step3",
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "prgStep3",
    attrs: {
      "label-width": "110px"
    },
    model: {
      value: (_vm.doc),
      callback: function($$v) {
        _vm.doc = $$v
      },
      expression: "doc"
    }
  }, [(this.doc) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('select-users', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step.updated_by),
      callback: function($$v) {
        _vm.$set(_vm.step, "updated_by", $$v)
      },
      expression: "step.updated_by"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('select-action-status', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step.status),
      callback: function($$v) {
        _vm.$set(_vm.step, "status", $$v)
      },
      expression: "step.status"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('select-priority', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step.priority),
      callback: function($$v) {
        _vm.$set(_vm.step, "priority", $$v)
      },
      expression: "step.priority"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("Approvals")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [_c('span', [_vm._v("Submitted")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [_c('span', [_vm._v("Completed")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8,
      "align": "center"
    }
  }, [_c('span', [_vm._v("Approved")])])], 1), _vm._v(" "), _vm._l((_vm.doc.approvals), function(item, index) {
    return _c('el-row', {
      key: index
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": item.approver
      }
    }, [_c('el-date-picker', {
      attrs: {
        "id": 'sub' + index,
        "format": _vm.dateFormat,
        "placeholder": "Submitted",
        "disabled": _vm.dis
      },
      model: {
        value: (item.submittedOn),
        callback: function($$v) {
          _vm.$set(item, "submittedOn", $$v)
        },
        expression: "item.submittedOn"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', [_c('el-date-picker', {
      attrs: {
        "id": 'comp' + index,
        "format": _vm.dateFormat,
        "placeholder": "Completed",
        "disabled": _vm.dis
      },
      on: {
        "change": function($event) {
          return _vm.completedDate(item.completedOn, item.completed)
        }
      },
      model: {
        value: (item.completedOn),
        callback: function($$v) {
          _vm.$set(item, "completedOn", $$v)
        },
        expression: "item.completedOn"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('el-form-item', [_c('el-switch', {
      attrs: {
        "id": 'compYN' + index,
        "active-text": "Yes",
        "inactive-text": "No",
        "width": 58,
        "active-color": "#5ccdcd",
        "inactive-color": "#cd5c5c",
        "disabled": _vm.dis
      },
      on: {
        "change": function($event) {
          return _vm.completedToggle(item.completedOn, item.completed)
        }
      },
      model: {
        value: (item.completed),
        callback: function($$v) {
          _vm.$set(item, "completed", $$v)
        },
        expression: "item.completed"
      }
    })], 1)], 1)], 1)
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('section', [_c('h5', [_vm._v("General Remarks")]), _vm._v(" "), _c('div', [_c('html-input', {
    attrs: {
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step.remarks),
      callback: function($$v) {
        _vm.$set(_vm.step, "remarks", $$v)
      },
      expression: "step.remarks"
    }
  })], 1), _vm._v(" "), (_vm.step.remarks) ? _c('hr') : _vm._e()]), _vm._v(" "), _c('el-row', [_c('h3', [_vm._v("Review & Approval")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [(_vm.step) ? _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Reviewer"
    }
  }, [_c('select-users', {
    attrs: {
      "manager": ""
    },
    model: {
      value: (_vm.step.approved_by),
      callback: function($$v) {
        _vm.$set(_vm.step, "approved_by", $$v)
      },
      expression: "step.approved_by"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.step) ? _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Review Date",
      "required": ""
    }
  }, [_c('el-date-picker', {
    attrs: {
      "format": _vm.dateFormat,
      "placeholder": "Reviewed",
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step.approved_at),
      callback: function($$v) {
        _vm.$set(_vm.step, "approved_at", $$v)
      },
      expression: "step.approved_at"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.step) ? _c('el-col', {
    attrs: {
      "span": 4,
      "offset": 2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "Yes",
      "inactive-text": "No",
      "active-color": "#5ccdcd",
      "inactive-color": "#cd5c5c",
      "disabled": _vm.dis
    },
    model: {
      value: (_vm.step.approved),
      callback: function($$v) {
        _vm.$set(_vm.step, "approved", $$v)
      },
      expression: "step.approved"
    }
  })], 1)], 1) : _vm._e()], 1)], 2), _vm._v(" "), (_vm.rowData.id) ? _c('files-panel', {
    attrs: {
      "type": "site",
      "id": _vm.rowData.site_id,
      "process": "progress",
      "process-id": _vm.rowData.id,
      "disabled": _vm.dis,
      "max-files": 20
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74951a66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress/ProgressStep3.vue
// module id = 1559
// module chunks = 0